import {COLLECT_ENDPOINT} from '../constant/Application';

class ApiService {
  static delay (amount) {
    return new Promise(resolve => {
      window.setTimeout(resolve, amount);
    });
  }

  static async submit (formValues) {
    const url = COLLECT_ENDPOINT;

    try {
      // TODO - remove this line, added for development purposes only
      await ApiService.delay(1e3);

      const response = await fetch(url, {
        method  : 'POST',
        body    : JSON.stringify(formValues),
        headers : {
          Accept         : 'application/json',
          'Content-Type' : 'application/json'
        }
      });

      if (response.ok && /2[0-9]{2}/.test(response.status)) {
        const asJson = await response.json();

        return {
          success : true,
          data    : asJson,
          error   : null
        };
      }

      return {
        success : false,
        data    : null,
        error   : response.status
      };
    } catch (error) {
      console.error('Encountered error while submitting', error);

      return {
        success : false,
        data    : null,
        error
      };
    }
  }
}

export default ApiService;
